import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit/types/TDeviceType';

import { INewReviewReducerState } from '../../../reducers/newReview';

export function trackShow(
  objectId: number,
  publishedReviewId: number | null,
  rating: INewReviewReducerState['data'],
  deviceType: TDeviceType,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'show',
    label: 'Write_Success_Submit',
    page: {
      pageType: 'ReviewsDailyrent',
      siteType: deviceType === 'desktop' ? 'desktop' : 'mobile',
      extra: {
        ratings: {
          total: rating.overallScore,
          politeness: rating.polite,
          price_quality: rating.priceAndQuality,
          infrastructure: rating.location,
          comfort_appliances: rating.comfortAndAppliance,
          tidiness: rating.cleaning,
        },
        review_id: publishedReviewId,
      },
    },
    products: [{ id: objectId, offerType: 'offer' }],
  });
}
